module.exports = __webpack_public_path__ + "img/home-book-cover.7bec1dd0.jpg";